import { render, staticRenderFns } from "./DidntReturnStaffGistSubHeader.vue?vue&type=template&id=1e565f54&scoped=true"
import script from "./DidntReturnStaffGistSubHeader.vue?vue&type=script&lang=js"
export * from "./DidntReturnStaffGistSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e565f54",
  null
  
)

export default component.exports